var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "value": _vm.open,
      "onClose": _vm.close,
      "close": false
    }
  }, [_c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "busca",
    attrs: {
      "md": "6"
    }
  }, [_c('Input', {
    ref: "descricao",
    attrs: {
      "label": "Descrição",
      "id": "descricao",
      "labelBold": ""
    },
    on: {
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valueProduto.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "descricao", $$v);
      },
      expression: "valueProduto.descricao"
    }
  })], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.valueProduto.lote,
      "id": "quantidade",
      "name": "quantidade"
    },
    model: {
      value: _vm.valueProduto.quantidade,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "quantidade", $$v);
      },
      expression: "valueProduto.quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Valor Unitário",
      "label-for": "preco"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "preco",
      "name": "preco"
    },
    model: {
      value: _vm.valueProduto.preco,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "preco", $$v);
      },
      expression: "valueProduto.preco"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Desconto",
      "label-for": "desconto"
    }
  }, [_c('b-input-group', [_vm.descontoTipo === 'valor' ? _c('money', _vm._b({
    key: 'desconto-valor-' + _vm.descontoInputKey,
    staticClass: "form-control",
    attrs: {
      "id": "desconto",
      "name": "desconto"
    },
    model: {
      value: _vm.valueProduto.desconto,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "desconto", $$v);
      },
      expression: "valueProduto.desconto"
    }
  }, 'money', _vm.configMask, false)) : _c('b-form-input', {
    key: 'desconto-percentual-' + _vm.descontoInputKey,
    attrs: {
      "id": "desconto",
      "name": "desconto",
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01"
    },
    model: {
      value: _vm.valueProduto.desconto,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "desconto", _vm._n($$v));
      },
      expression: "valueProduto.desconto"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.toggleDescontoTipo
    }
  }, [_vm._v(" " + _vm._s(_vm.descontoTipo === "valor" ? "R$" : "%") + " ")])], 1)], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total de Item R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "total",
      "name": "total",
      "disabled": ""
    },
    model: {
      value: _vm.totalProduto,
      callback: function callback($$v) {
        _vm.totalProduto = $$v;
      },
      expression: "totalProduto"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "observacao",
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacao",
      "name": "observacao",
      "placeholder": ""
    },
    model: {
      value: _vm.valueProduto.informacoesAdicionais,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "informacoesAdicionais", $$v);
      },
      expression: "valueProduto.informacoesAdicionais"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "confirm-buttons"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("Fechar")]), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function click() {
        _vm.save();
        _vm.close();
      }
    }
  }, [_vm._v("Gravar")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };